import { useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { ChevronDownIcon, WrenchScrewdriverIcon } from "@heroicons/react/24/outline";
import RoleOnly from "../../../routes/roleOnly";
import { DashboardAdminSetupAlerts } from "../companyGuide/DashboardAdminSetupAlerts";
import { DashboardUserSetupAlerts } from "../userGuide/DashboardUserSetupAlerts";

import { DashboardSetupContext } from "./dashboardSetupContext";

export function DashboardSetupOverview() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [areas, setAreas] = useState({});
  const register = useCallback((key, count) => {
    setAreas((previous) => {
      if (previous[key] === count) return previous;
      const next = { ...previous };
      if (count == null) delete next[key];
      else next[key] = count;
      return next;
    });
  }, []);
  const summary = useMemo(() => ({ areas: Object.keys(areas).length, count: Object.values(areas).reduce((sum, count) => sum + count, 0) }), [areas]);
  return (
    <DashboardSetupContext.Provider value={register}>
      <section className="pd-card pd-setup" hidden={!summary.areas}>
        <div className="pd-setup-head">
          <span className="pd-setup-icon"><WrenchScrewdriverIcon /></span>
          <div className="pd-setup-title"><h2>{t("dashboardDesign.setup")}</h2><p>{t("dashboardDesign.setupCount", summary)}</p></div>
          <button type="button" className="pd-button" aria-expanded={open} aria-controls="dashboard-setup-areas" onClick={() => setOpen((value) => !value)}>{t(open ? "dashboardDesign.hide" : "dashboardDesign.showAll")}<ChevronDownIcon className={open ? "rotate-180" : ""} /></button>
        </div>
        <div id="dashboard-setup-areas" className="pd-setup-areas" hidden={!open}>
          <DashboardUserSetupAlerts />
          <RoleOnly role="admin"><DashboardAdminSetupAlerts /></RoleOnly>
        </div>
      </section>
    </DashboardSetupContext.Provider>
  );
}
